import { Component } from "@angular/core";
import { LoadingService } from "app/services/common/loading_service";

@Component({
  selector: 'app-loading',
  template: `
    <div class="loading-backdrop" *ngIf="loading$ | async">
      <div class="spinner"></div>
    </div>
  `,
  styleUrls: ['loading.component.css']
})
export class LoadingComponent {
  loading$ = this.loadingService.loading$;
  constructor(private loadingService: LoadingService) {}
}
